<template lang="pug">
vm-row.information__wrapper(vm-w="12" vm-type="flex" vm-justify="center")
  vm-col.card__wrapper(vm-sm=12 vm-md=6 vm-lg=12)
    .card.card-flex2
      .card-body
        vm-table(max-height="350px" :data="detailsList" class="table")
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('quotations_detail.' + column) }}
            vm-th &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                slot(v-if="column == 'supplier_id'") {{data[indextr]['supplier'].name | truncate(15)}}
                slot(v-if="column == 'individual_delivery_time  '") {{data[indextr]['individual_delivery_time ']}}
                slot(v-if="column == 'product_id'") {{data[indextr]['product'].name}}
                slot(v-if="column == 'number_part'") {{data[indextr]['product'].number_part}}
                slot(v-if="column == 'quantity'") {{data[indextr]['quantity'] }}
                slot(v-if="column == 'unit_cost'") {{data[indextr]['unit_price'] | currency }}
                slot(v-if="column == 'sub_unit_cost'") {{parseFloat(data[indextr]['unit_price']) * parseFloat(data[indextr]['quantity']) | currency }}
                slot(v-if="column == 'utility'") {{parseFloat(data[indextr]['utility']).toFixed(2)+'%'}}
                slot(v-if="column == 'utility_amount'") {{data[indextr]['utility_amount'] | currency }}
                slot(v-if="column == 'utility_sub'") {{data[indextr]['utility_subtotal'] | currency }}
                slot(v-if="column == 'price'") {{data[indextr]['price'] | currency }}
                slot(v-if="column == 'pu'") {{data[indextr]['pu'] | currency }}
                slot(v-if="column == 'subtotal'") {{data[indextr]['subtotal'] | currency }}
                slot(v-if="column == 'flete'") {{data[indextr]['flete'] | currency }}
                slot(v-if="column == 'total'") {{data[indextr]['total'] | currency }}

  .floating_utility
    span.utility__text Total Utilidad
    span.utility_amount {{ money_utility | currency }}
</template>

<script>
export default {
  name: 'SaleQuotationDetailsTable',
  props: {
    sale: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    columns: [
      'supplier_id',
      'quantity',
      'product_id',
      'number_part',
      'unit_cost',
      'sub_unit_cost',
      'utility',
      'utility_amount',
      'utility_sub',
      'price',
      'pu',
      'subtotal',
      'flete',
      'total'
    ]
  }),
  computed: {
    detailsList () {
      if (this.sale.quotation) {
        let t = this
        return this.sale.quotation.details.map((detail, index) => {
          (parseFloat(detail.unit_price_raw) === 0.00) && (detail.unit_price_raw = detail.unit_price)
          if (detail.edit !== undefined && (parseInt(detail.product.currency_id) !== parseInt(t.sale.currency_id))) {
            (parseInt(detail.product.currency_id) === 1 ? detail.unit_price = parseFloat(parseFloat(detail.unit_price_raw) * parseFloat(t.sale.exchange_rate)).toFixed(5) : detail.unit_price = parseFloat(parseFloat(detail.unit_price_raw) / t.sale.exchange_rate).toFixed(5))
          } else if (parseInt(detail.product.currency_id) !== parseInt(t.sale.currency_id)) {
            (parseInt(detail.product.currency_id) === 1 ? detail.unit_price = parseFloat(parseFloat(detail.unit_price_raw) * parseFloat(t.sale.exchange_rate)).toFixed(5) : detail.unit_price = parseFloat(parseFloat(detail.unit_price_raw) / t.sale.exchange_rate).toFixed(5))
          } else {
            detail.unit_price = parseFloat(detail.unit_price_raw)
          }
          if (t.sale.type_utility) detail.utility = parseFloat(t.sale.utility).toFixed(5)
          detail.index = index
          detail.price = parseFloat(detail.unit_price / ((100 - parseFloat(detail.utility)) / 100)).toFixed(5)
          detail.utility_amount = parseFloat(detail.price - detail.unit_price).toFixed(5)
          detail.utility_subtotal = (parseFloat(detail.quantity) * parseFloat(detail.utility_amount)).toFixed(5)
          detail.subtotal = (parseFloat(detail.price) * parseFloat(detail.quantity)).toFixed(5)
          t.sale.quotation.type_fletes ? detail.flete = t.getFlete(detail.subtotal) : detail.flete = 0
          detail.total = parseFloat(detail.total)
          if (parseFloat(this.sale.quotation.flete) > 0) {
            detail.pu = ((parseFloat(this.sale.quotation.flete) / parseFloat(detail.quantity)) + (parseFloat(detail.price)))
          } else {
            detail.pu = parseFloat(detail.price)
          }
          return detail
        })
      }
    },
    money_utility () {
      if (this.sale.money_utility) {
        return this.sale.money_utility
      } else {
        return this.$t('sale.error')
      }
    }
  },
  methods: {
    getFlete (value) {
      let subtotal = this.sale.quotation.details.reduce((prev, cur) => prev + parseFloat(cur.subtotal), 0).toFixed(5)
      let percent = (value * 100) / subtotal
      return ((percent * this.sale.quotation.flete) / 100).toFixed(5)
    }
  }
}
</script>

<style lang="scss" scoped>
.information__wrapper {
  .card__wrapper {
    padding: 15px;
  }
  .card {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px !important;
    height: 100% !important;
    .card-body {
      padding: 10px !important;
      width: 100%;
      height: 100%;
    }
  }
}

.card-flex2 {
  display: flex;
  flex-direction: column;
}

.card {
  padding: 10px !important;
  height: 100% !important;
  .card-body {
    padding: 10px !important;
    width: 100%;
    height: 100%;
  }
}

.gutters {
  padding: 20px;
}

.floating_utility {
  display: none;
}

.table {
  padding-left: 0 !important;
  .vm-table-text {
    padding-left: 0 !important;
  }
}

@media screen and (min-width: 992px) {
  .floating_utility {
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 20px;
    right: 20px;
    background-color: #0082aa;
    padding: 10px;
    z-index: 20000;
    border-radius: 0.5em;
    span {
      color: #fff;
      padding: 10px;
      &:last-child {
        font-weight: bold;
      }
    }
  }
}
</style>
